import ModalMainWrapper from './ModalMainWrapper'
import ModalContentWrapper from './ModalContentWrapper'
import ModalHeader from './ModalHeader'
import ModalContent from './ModalContent'

export default function GeneralModal({ title, children }) {
    return (
        <ModalMainWrapper>
            <ModalContentWrapper>
                <ModalHeader title={title} />
                <ModalContent>{children}</ModalContent>
            </ModalContentWrapper>
        </ModalMainWrapper>
    )
}
